import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import { ScreenProps } from '../ScreenBase';

class Redirect extends React.Component<ScreenProps> {

  doRedirect = () => {
    
    if(this.props.data.extended_props && this.props.data.extended_props.url)  {
      window.location.href = this.props.replaceTokens(this.props.data.extended_props.url, this.props.responses);
    }
  }

  async componentDidMount() {
    await this.props.onSubmit({});
    if(this.props.isActive) this.doRedirect();
  }

  async componentDidUpdate() {
    if(this.props.isActive) this.doRedirect();
  }

  render() {
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
    return <Spin indicator={antIcon} />;
  }
}

export default Redirect;
